import { normalize } from 'normalizr';
import gameEntity from './entity';

export default (games) => normalize(games, [gameEntity]);
